import Vue from "vue";
import Vuex from "vuex";
import pathify from "vuex-pathify";

import datamodule from "./store/data";
import dialogmodule from "./store/dialog";
import state from "./store/state";

Vue.use(Vuex);

export default new Vuex.Store({
  // Enable the vuex-pathify plugin.
  plugins: [pathify.plugin],
  state,
  mutations: {},
  actions: {},
  modules: { datamodule, dialogmodule }
});
